// src/components/panel/PanelAdministrativo.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/panel/panel.css";

const PanelAdministrativo = () => {
  const navigate = useNavigate();

  // ✅ Guard: si no hay token, mandar al login
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  // Navegación (igual que tu Dashboard)
  const navigateTo = (dest) => {
    if (
      dest.startsWith("http") ||
      dest.startsWith("https") ||
      dest.startsWith("anydesk://")
    ) {
      window.open(dest, "_blank");
    } else {
      navigate(dest);
    }
  };

  // ====== Modal Administrar Saldos ======
  const [saldosOpen, setSaldosOpen] = useState(false);

  const saldosButtons = [
    {
      key: "cpp",
      name: "Cuentas Por Pagar",
      icon: "https://floristeria2000.com/wp-content/uploads/2025/12/por-pagar.png",
      route: "/modificar-saldos-cxp",
    },
    {
      key: "cpc",
      name: "Cuentas Por Cobrar",
      icon: "https://floristeria2000.com/wp-content/uploads/2025/12/por-cobrar.png",
      route: "/modificar-saldos-cxc",
    },
  ];

  const openSaldo = (item) => {
    if (item?.route) navigateTo(item.route);
  };

  // Cerrar modal con Escape
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setSaldosOpen(false);
    };
    if (saldosOpen) window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [saldosOpen]);

  return (
    <div className="panel-content">
      <header className="panel-header">
        <h1>Panel administrativo</h1>
        <p>Bienvenido/a</p>
      </header>

      <section className="panel-section">
        <h2>Opciones Administrativas</h2>

        <div className="panel-buttons-grid">
          {/* 1- Administrar Caja */}
          <div
            className="panel-button-card"
            onClick={() => navigateTo("/administrar-caja")}
          >
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/caja.png"
              alt="Administrar Caja"
              className="panel-button-icon"
            />
            <h3>Administrar Caja</h3>
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateTo("/administrar-caja");
              }}
            >
              Ir
            </button>
          </div>

          {/* 2- Administrar Saldos (Modal) */}
          <div
            className="panel-button-card"
            onClick={() => setSaldosOpen(true)}
          >
            <img
              src="https://floristeria2000.com/wp-content/uploads/2026/01/historial.webp"
              alt="Administrar Saldos"
              className="panel-button-icon"
            />
            <h3>Administrar Saldos</h3>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSaldosOpen(true);
              }}
            >
              Abrir
            </button>
          </div>

          {/* 3- Anular Ordenes */}
          <div
            className="panel-button-card"
            onClick={() => navigateTo("/anular-ordenes")}
          >
            <img
              src="https://floristeria2000.com/wp-content/uploads/2025/12/facturas.png"
              alt="Anular Ordenes"
              className="panel-button-icon"
            />
            <h3>Anular Ordenes</h3>
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateTo("/anular-ordenes");
              }}
            >
              Ir
            </button>
          </div>
        </div>
      </section>

      {/* ===== Modal Administrar Saldos ===== */}
      {saldosOpen && (
        <div
          className="panel-modal-overlay"
          onClick={() => setSaldosOpen(false)}
        >
          <div
            className="panel-modal-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="panel-modal-close"
              onClick={() => setSaldosOpen(false)}
              aria-label="Cerrar"
            >
              ×
            </button>

            <div className="panel-modal-header">
              <h2>ADMINISTRAR SALDOS</h2>
              <p>Selecciona a cuál módulo deseas ingresar</p>
            </div>

            <div className="panel-modal-separator" />

            <div className="panel-modal-grid">
              {saldosButtons.map((item) => (
                <div
                  key={item.key}
                  className="panel-button-card panel-modal-item-card"
                  onClick={() => openSaldo(item)}
                >
                  <img
                    src={item.icon}
                    alt={item.name}
                    className="panel-button-icon"
                  />
                  <h3>{item.name}</h3>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openSaldo(item);
                    }}
                  >
                    Abrir
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelAdministrativo;
